import React from "react";
import styled from "styled-components/macro";
import financingStyle from "./Financing.style";
import { useLendicaContext } from "../../hooks/useLendicaContext";

const FinancingContainerWrapper = styled.div`
  ${financingStyle}
`;

const Financing = () => {
  const { lendica } = useLendicaContext();

  return (
    <FinancingContainerWrapper>
      <div className="marketing-container">
        <div className="header-section">
          <div className="logo-container">
            <img src="https://uploads-ssl.webflow.com/653ffb78da26dd654661522e/65e26052fea2a84e334c94d6_idPCglRaAU.png"
              alt="partner logo" className="partner-logo" height="36" />

            <img src="/static/assets/icons/plus.svg" alt="Plus" className="x-symbol" width="36" height="36" />

            <img src="/static/assets/logos/lendica-blue.svg" alt="Lendica Logo" className="lendica-logo" />
          </div>

          <h1 className="main-headline">
            PLATFORM has partnered with Lendica to offer you fast and affordable working capital products. Delay your
            vendor payments with PayLater line of credit. Speed up cash collection with FundNow invoice factoring.
          </h1>
        </div>

        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">
              <img src="/static/assets/icons/InstantDecision.svg" alt="Fast Decision" width="36" height="36" />
            </div>
            <h3 className="feature-title">
              Fast<br />decision
            </h3>
            <p className="feature-description">
              Apply in minutes and<br />get near-instant decision.
            </p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <img src="/static/assets/icons/MonetizationOn.svg" alt="Fair Pricing" width="36" height="36" />
            </div>
            <h3 className="feature-title">
              Fair<br />pricing
            </h3>
            <p className="feature-description">
              Transparent rates based on your operation metrics.
            </p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <img src="/static/assets/icons/AddModerator.svg" alt="Credit-safe process" width="36" height="36" />
            </div>
            <h3 className="feature-title">
              Credit-safe<br />process
            </h3>
            <p className="feature-description">
              No impact on your credit even if not approved.
            </p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              <img src="/static/assets/icons/Meter.svg" alt="Usage-based fees" width="36" height="36" />
            </div>
            <h3 className="feature-title">
              Usage-based<br />fees
            </h3>
            <p className="feature-description">
              No fees until you draw down capital.
            </p>
          </div>
        </div>

        <div className="cta-section">
          <button className="cta-button" onClick={() => lendica.current.ibranch.open()}>
            Learn more
          </button>
        </div>
      </div>
    </FinancingContainerWrapper>
  );
}

export default Financing;
